app.factory('authService', ['$q', 'baseService', 'objectHelper', 'config',
    function ($q, baseService, objectHelper, config) {

        function AuthService() {

            this.authenticate = function (username, password) {
                return baseService.post(config.AUTH_URL, $.param({username: username, password: password}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.invalidate = function () {
                return baseService.post(config.LOGOUT_URL).then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };


        }

        return new AuthService();
    }
]);
